import { BREAKPOINTS } from './settings';
const SCRIPT_ID = 'webgl-script';


const dispatchCustomEvent = (type: 'build' | 'destroy') => {
  const event = new CustomEvent(`webgl:${type}`);
  if(window) window.dispatchEvent(event);
};

const createScript = (script_id) => {
  if(document.getElementById(script_id)) return;

  return new Promise<void>((resolve) => {
    const script = document.createElement('script');
    script.addEventListener('load', () => resolve());
    script.id = script_id;
    script.src = '/app.js';
    script.type = 'module';
    document.body.appendChild(script);
  });
};

const mediaQueryTester = (breakpoint: number) => (): Boolean => window.matchMedia(`(min-width: ${breakpoint}px)`).matches;

const mediaQuery = (breakpoint: number, smallCallback: () => void, largeCallback: () => void) => {
  const testMediaQuery = mediaQueryTester(breakpoint);
  const useLSmallOrLarge = matches => matches ? largeCallback() : smallCallback();

  let prevState = testMediaQuery();

  useLSmallOrLarge(prevState);

  if(window) window.onresize = () => {
    const currState = testMediaQuery();
    if(currState !== prevState) {
      useLSmallOrLarge(currState);
      prevState = currState;
    }
  };
}

const buildWebgl = () => dispatchCustomEvent('build');
const destroyWebgl = () => dispatchCustomEvent('destroy');

const initializeWebgl = async () => {

  await createScript(SCRIPT_ID);

  mediaQuery(BREAKPOINTS.medium, destroyWebgl, buildWebgl);
};

export { destroyWebgl, initializeWebgl };
